import { render, staticRenderFns } from "./upload-card.vue?vue&type=template&id=d220ccd6&scoped=true&"
import script from "./upload-card.vue?vue&type=script&lang=js&"
export * from "./upload-card.vue?vue&type=script&lang=js&"
import style0 from "./upload-card.vue?vue&type=style&index=0&id=d220ccd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d220ccd6",
  null
  
)

export default component.exports